
export const Constants = new ConstantsObj();

function ConstantsObj() {
    /**
     NOTE: When adding new EntityTree Types, please update the EntityTreeBuilder class
     to match the configurations here.
     */
    this.TYPE_ADMINNODE = 0;
    this.TYPE_GROUP = 1;
    this.TYPE_SUBSYSTEM_LIST_ITEM = 2;

    // Immediately poll the EditLock.act endpoint to begin long polling.
    this.EDIT_LOCK_POLL_INTERVAL_MS = 1000 * WebpackConfig.ent.editLock.delayTimeInSecBetweenEachPoll || 0;

    // In 5 minutes of Idle time, automatically release the edit lock the user has.
    this.EDIT_LOCK_IDLE_TIMEOUT_MS = 1000 * WebpackConfig.ent.editLock.idleTimeInSecUntilEditLockIsAutomaticallyReleased || 300000;

    // Expected response from EditLock.act endpoint to indicate to the client that it
    // should continue polling the server.
    this.OK = "OK";
}

export function tryToSetupDebugMode() {
    const { ent } = WebpackConfig;
    console.log(ent.welcomeConsoleLog || "Running Ent Webpack Module");
}